export default __webpack_public_path__ + "static/media/filling_8.9a5d8430.jpg";